import { render, staticRenderFns } from "./EditAlokasi.vue?vue&type=template&id=ef1b8ef6&scoped=true&"
import script from "./EditAlokasi.vue?vue&type=script&lang=js&"
export * from "./EditAlokasi.vue?vue&type=script&lang=js&"
import style0 from "./EditAlokasi.vue?vue&type=style&index=0&id=ef1b8ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1b8ef6",
  null
  
)

export default component.exports